import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { useClearStores } from "../hooks/use-clear-stores";

const SignOutCompoment = () => {
    const navigate = useNavigate();
    const clearAllStores = useClearStores();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Auth.signOut().then((res) => {
            clearAllStores();
            setLoading(false);
            navigate("/login");
        });
    },[])
    return (
        <>
        {loading? 
            <Loading />
            :<></>
        }
        </>
        
    )
}

export default SignOutCompoment;